import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICopyAttachmentsExecutorProps } from './ICopyAttachmentsExecutorProps';
import { CopyAttachmentsExecutorModal } from './CopyAttachmentsExecutorModal';

export const CopyAttachmentsExecutor = createDocModalExecutor<ICopyAttachmentsExecutorProps>({
    modal: CopyAttachmentsExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
